import { useInstanceStore } from 'src/stores/instance.js'

import fileSizeFormatService from 'src/services/file_size_format/file_size_format.js'
import { fileForUpload } from 'src/services/image_compression/image_compression.js'
import statusPoster from 'src/services/status_poster/status_poster.service.js'

// The sizes for the "file too big" message when the file is over the
// server's upload limit, else null. An unknown limit lets everything through.
export const overUploadLimit = (file) => {
  const limit = useInstanceStore().uploadlimit
  if (!(file.size > limit)) return null
  const filesize = fileSizeFormatService.fileSizeFormat(file.size)
  const allowedsize = fileSizeFormatService.fileSizeFormat(limit)
  return {
    filesize: filesize.num,
    filesizeunit: filesize.unit,
    allowedsize: allowedsize.num,
    allowedsizeunit: allowedsize.unit,
  }
}

// errorKey and args for the upload.error message
export class UploadError extends Error {
  constructor(errorKey, args = {}) {
    super(errorKey)
    this.errorKey = errorKey
    this.args = args
  }
}

// A picked file uploaded as an attachment, compressed when asked and
// possible: the server's attachment, and whether it was compressed. The
// limit is checked on the original, as the user picked it. onlyCompressed:
// nothing is uploaded (null) when the file would go up as it is.
export const uploadAttachment = async (
  file,
  { compress, jpegOnly, onlyCompressed = false },
) => {
  const tooBig = overUploadLimit(file)
  if (tooBig) throw new UploadError('file_too_big', tooBig)
  const upload = await fileForUpload(file, { compress, jpegOnly })
  if (onlyCompressed && !upload.compressed) return null
  const formData = new FormData()
  formData.append('file', upload.file)
  try {
    const fileData = await statusPoster.uploadMedia({ formData })
    return { fileData, compressed: upload.compressed }
  } catch (error) {
    console.error('Error uploading file', error)
    throw new UploadError('default')
  }
}
